// Components
export const LOGIN_PAGE: string = "LoginPage";

// Portal Type
export const MATCHING_ENGINE = 'MatchingEngine';
export const MEMBERS_PORTAL = 'MembersPortal';

export const AAD_LOGIN_TYPE = 'AAD';
export const B2C_LOGIN_TYPE = 'B2C';

//Clients
export const CLIENTS = ['SOCAN'];
export const DEFAULT_CLIENT = 'spanishpoint';

// Cache Defaults
export const DEFAULT_IP_NAME_NUMBER = "00000";
export const DEFAULT_IP_BASE_NUMBER = "00000";
export const DEFAULT_ACCOUNT_NUMBER = "00000";
export const DEFAULT_GUID = "00000";

